import { render, staticRenderFns } from "./desktop-download-link.vue?vue&type=template&id=c05c790e&scoped=true&"
import script from "./desktop-download-link.vue?vue&type=script&lang=js&"
export * from "./desktop-download-link.vue?vue&type=script&lang=js&"
import style0 from "./desktop-download-link.vue?vue&type=style&index=0&id=c05c790e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05c790e",
  null
  
)

export default component.exports